<template>
	<!-- <ProfileDebug /> -->
	<div class="trucker">
		<div
			class="trucker__cargos-list"
			v-if="tripsOnTheWay?.length"
		>
			<PagesTruckerCargoCards
				v-for="trip in tripsOnTheWay"
				:key="trip.id"
				:trip="trip"
				class="cargo-item"
				@getTripsOnTheWay="getTripsOnTheWay"
			/>
		</div>
		<div
			v-else-if="loading?.getTripsOnTheWay"
			class="loading"
		>
			<UiLoader
				:circleWidth="2"
				:radius="20"
				color="var(--white)"
			/>
		</div>
		<div
			v-else-if="loadError"
			class="empty"
		>
			<div class="load-error">
				<TypographyKTypographyBody3 color="#fff">{{ loadError }}</TypographyKTypographyBody3>
				<UiButton
					:color="ButtonType.primary"
					@click="getTripsOnTheWay()"
				>
					Повторить
				</UiButton>
			</div>
		</div>
		<div
			v-else
			class="empty"
		>
			<TypographyKTypographyBody3 color="#fff"> Рейсы в статусе "В пути" отсутствуют </TypographyKTypographyBody3>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { useLongHaulTripStore } from '~/store/longHaulTrip.store';
	import { ButtonType } from '~~/shared/interfaces/ui';

	const longHaulTripStore = useLongHaulTripStore();
	const tripsOnTheWay = storeToRefs(longHaulTripStore).tripsOnTheWay;
	const { loading } = storeToRefs(longHaulTripStore);
	const loadError = ref<string | null>(null);

	const getTripsOnTheWay = async (isDisabledErrroMessage = false) => {
		loadError.value = null;
		try {
			const result = await longHaulTripStore.getTripsOnTheWay(isDisabledErrroMessage);
			if (result.status === 'success') {
				void longHaulTripStore.prefetchSntReportsForTrips(result.data);
			}
			if (result.status !== 'success') {
				const error = result.error as { statusCode?: number; statusMessage?: string; message?: string } | null;
				loadError.value =
					error?.statusCode || error?.statusMessage || error?.message || 'Сервер не вернул успешный ответ.';
			}
		} catch (error) {
			loadError.value = error instanceof Error ? error.message : 'Не удалось выполнить запрос за рейсами.';
			console.error('Failed to request trips on the way:', error);
		}
	};

	onMounted(() => {
		getTripsOnTheWay();
	});
</script>

<style lang="scss" scoped>
	.empty {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		height: 100%;
	}
	.load-error {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 12px;
	}
	.trucker {
		display: flex;
		flex-direction: column;
		height: 100%;

		&__cargos-list {
			display: flex;
			flex-direction: column;
			gap: 12px;
			margin-top: 20px;
		}
	}

	.loading {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
	}
</style>
